import type { Locale } from "../i18n/config";

const defaultLocale: Locale = "en";
const locales = ["en", "ja"] as const;

export const sharedLocaleCookieName = "avacus_locale";
export const legacyLocaleCookieNames = ["language", "i18next"] as const;
export const localeCookieNames = [
  sharedLocaleCookieName,
  ...legacyLocaleCookieNames,
] as const;

export function normalizeLocale(
  locale: string | null | undefined
): Locale | null {
  const normalizedLocale = locale?.split("-")[0]?.toLowerCase();
  if (locales.includes(normalizedLocale as Locale)) {
    return normalizedLocale as Locale;
  }
  return null;
}

export function getLocaleCookieDomain(
  hostname: string | null | undefined
): string | undefined {
  const normalizedHostname =
    (hostname ?? "").split(":")[0]?.toLowerCase() ?? "";
  return normalizedHostname === "avacus.cc" ||
    normalizedHostname.endsWith(".avacus.cc")
    ? ".avacus.cc"
    : undefined;
}

export function getCookieValue(
  cookieHeader: string,
  name: string
): string | null {
  let value: string | null = null;
  for (const cookie of cookieHeader.split(";")) {
    const [cookieName, ...cookieValueParts] = cookie.trim().split("=");
    if (cookieName === name) value = cookieValueParts.join("=");
  }
  return value;
}

export function resolveLocale({
  cookieValues = [],
  browserLocale,
  fallback = defaultLocale,
}: {
  cookieValues?: Array<string | null | undefined>;
  browserLocale?: string | null;
  fallback?: Locale;
}): Locale {
  return (
    cookieValues.map(normalizeLocale).find(Boolean) ??
    normalizeLocale(browserLocale) ??
    fallback
  );
}

export function serializeLocaleCookie(
  name: string,
  locale: Locale,
  hostname?: string | null
): string {
  const maxAge = 31536000;
  const domain = getLocaleCookieDomain(
    hostname ??
      (typeof window !== "undefined" ? window.location.hostname : null)
  );
  const domainPart = domain ? `; domain=${domain}` : "";
  return `${name}=${locale}; path=/; max-age=${maxAge}; SameSite=Lax${domainPart}`;
}
